import { getCookieValue } from '@/helpers/cookies';
import { DividaResource } from '@/models/resources';
import { storageService, serverTimeService } from '@/services';
import { EventParameters } from './eventSignatures';

type StandardParams = Pick<EventParameters, 'data' | 'device_id' | 'consumidor_id'>

export async function makeStandard(addConsumidor = true): Promise<StandardParams> {
  return {
    data: serverTimeService.syncedTime.toISOString(),
    device_id: getCookieValue('_acerto_did'),
    consumidor_id: addConsumidor ? storageService.hash.get() : undefined,
  };
}

export type DividaEventArgs = Pick<DividaResource, 'credor' | 'id' | 'produto'>
type DividaParams = Pick<EventParameters, 'nome_credor' | 'divida_id' | 'produto'>

export function makeDivida(divida: DividaEventArgs): DividaParams {
  return {
    nome_credor: divida.credor,
    divida_id: divida.id,
    produto: divida.produto || '',
  };
}
